import { useQuery } from "@tanstack/react-query";
import api from "@app/services/api";
import { apiEndpoints } from "@app/utils/constants";
import type { UseQueryOptions } from "@tanstack/react-query";
import type {
  ApiError,
  LocationListParams,
  LocationListResponse,
} from "@app/services/api.types";

type QueryOptions = Omit<
  UseQueryOptions<LocationListResponse, ApiError>,
  "queryKey" | "queryFn"
>;

export const fetchLocationList = async (
  params: LocationListParams
): Promise<LocationListResponse> => {
  const url = apiEndpoints.locations.getList(params);
  const response = await api.get(url);
  return response?.data?.data;
};

const useLocationList = (
  params: LocationListParams,
  options?: QueryOptions
) => {
  return useQuery<LocationListResponse, ApiError>({
    queryKey: ["location", "list", params],
    queryFn: () => fetchLocationList(params),
    ...options,
  });
};

export default useLocationList;
